// A frame that takes a separate seatpost must never be shown with its saddle
// floating: suggest a default post (visible and priced) until one is chosen.
export function defaultSeatpost(seatposts = []) {
  const name = post => (post && post.name || '').trim();
  return seatposts.find(post => /^enve seatpost$/i.test(name(post)))
    || seatposts.find(post => /enve/i.test(name(post)))
    || seatposts[0] || null;
}

// Build ids and the selection itself are positional (one entry per step, in
// order), so the post is only added once every earlier step is filled.
export function preselectSeatpost(selection, seatposts, steps) {
  const stepIndex = steps.findIndex(step => step.id === 'seatposts');
  if (stepIndex < 0 || selection.length !== stepIndex) return selection;
  const prefix = steps.slice(0, stepIndex).every((step, i) => selection[i] && selection[i].item && selection[i].props.id === step.id);
  const post = prefix && defaultSeatpost(seatposts);
  if (!post) return selection;
  const step = steps[stepIndex];
  return selection.concat({ props: step, selected: seatposts.indexOf(post), item: { ...post, type: 'seatposts', step }, color: 0 });
}
